import { QueryClient } from '@tanstack/react-query';

import { MAX_RETRIES, retryTransient } from './queryRetry';

/**
 * The app's single QueryClient, kept OUTSIDE the React tree on purpose: plain service modules
 * (`src/services/*`) import it to read and write the very same cache the components use through
 * `QueryClientProvider`. That is what lets the legacy promise-returning helpers share React Query's
 * cache and its in-flight dedupe without rewriting their 28 call sites.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      gcTime: 10000,
    },
    queries: {
      gcTime: 30000,
      refetchOnWindowFocus: false,
      retry: retryTransient(MAX_RETRIES),
    },
  },
});

export default queryClient;
